export type UserProfileData = {
    exposedUserId: string,
    userDisplayName: string,
    functionalRoles: []
}

export class UserProfile {

    private static currentProfile: UserProfileData = {
        exposedUserId: "",
        userDisplayName: "",
        functionalRoles: []
    }

    public static ChangeUserProfile(exposedUserId: string, userDisplayName: string , functionalRoles: []) : void {
        this.currentProfile.exposedUserId = exposedUserId
        this.currentProfile.userDisplayName = userDisplayName
        this.currentProfile.functionalRoles = functionalRoles
    }

    public static GetUserProfile() : UserProfileData {
        return this.currentProfile
    }

    public static IsInFunctionalRole(functionalRoleName: string) : boolean {
        if (!functionalRoleName) return false 
        if (!this.currentProfile || !this.currentProfile.functionalRoles ) return false

        for(const row of this.currentProfile.functionalRoles) {
            if ( row === functionalRoleName ) return true
        }

        return false
    }
}